<template lang="pug">
v-container.suus__topic
  v-row(no-gutters, justify="center")
    v-col.d-flex.justify-end(cols="12", lg="10", offset-lg="1")
      TopicForm(ref="topicForm" v-if="canEditTopic", :isEdit="isEdit")
        template(v-slot:activator="{ handleSheet }")
          v-btn(
            text,
            @click="handleSheet(true)",
            color="textColor",
            :style="btnStyles"
          )
            v-icon(color="textColor", left) {{ editIcon }}
            | Thema bearbeiten
    v-col(cols="12", lg="10", offset-lg="1") 
      Topic(
        v-if="topicData && !topicLoading",
        :topic="topicData",
        :total-posts-count="totalPostsCount",
        :can-create-posts="canCreatePosts",
        :can-create-reactions="canCreateReactions"
        :topic-reactions="topicReactions"
      )
      TopicSkeleton(v-if="topicLoading")

    v-col.mt-6(cols="12", lg="10", offset-lg="1")
      Header(
        text="Antworten",
        :level="5",
        :customStyles="headerStyles",
        customClass="pt-2 mb-6"
      )
      TopicPostList(
        v-if="topicData",
        :topic-id="topicId",
        :total-posts-count="totalPostsCount",
        :can-create-posts="canCreatePosts",
        @optimistic-posts-count="handleOptimisticPostsCount",
        :viewContext="viewContext",
      )
</template>

<script lang="ts">
import { defineComponent, ref, computed, Ref, watch } from "vue"
import { Reaction, Topic as ITopic } from "suus-api"

import { createNamespacedHelpers } from "vuex"
const { mapState: mapTopicState } = createNamespacedHelpers("topic")

import AttachmentList from "../AttachmentList.vue"
import Header from "../UI/Header.vue"
import TopicForm from "../TopicForm/index.vue"
import Topic from "../Topic/Topic.vue"
import TopicSkeleton from "../Topic/TopicSkeleton.vue"

import { mdiChevronDown, mdiPencilOutline } from "@mdi/js"
import { mdiCommentPlusOutline } from "@mdi/js"

import Theme from "../../constants/theme"
import { ViewContext } from "concerns/useContextName"
import useTranslate from "features/common/translate/concerns/useTranslate"
import { PolymorphicType } from "features/common/shared/polymorphic"
import TopicPostList from "features/topics/posts/TopicPostList.vue"
const { mediumGrey } = Theme.colors.light
export default defineComponent({
  name: "TopicPage",
  components: {
    TopicForm,
    TopicPostList,
    Header,
    Topic,
    TopicSkeleton,
    AttachmentList,
  },
  data() {
    return {
      editIcon: mdiPencilOutline,
      newPostIcon: mdiCommentPlusOutline,
      totalPostsCount: 0,
      panelIcon: mdiChevronDown,
    }
  },
  computed: {
    btnStyles(): object {
      return {
        fontFamily: "system-ui",
        fontWeight: 700,
        letterSpacing: "0.05em",
      }
    },
    headerStyles(): object {
      return {
        borderTop: `1px solid ${mediumGrey}`,
      }
    },
    isEdit(): boolean {
      return !!this.$route.params.topic_id
    },
    canEditTopic(): boolean {
      return !!this.topicData?.links?.update_url
    },
    canCreatePosts(): boolean {
      return !!this.topicData?.links?.posts?.create_url
    },
    canCreateReactions(): boolean {
      return !!this.topicData?.links?.reactions?.create_url
    },
    topicId(): number {
      return parseInt(this.$route.params.topic_id)
    },
    attachable(): PolymorphicType {
      return {
        id: this.topicData?.id,
        type: "Topic",
      }
    },
    viewContext(): ViewContext {
      return {
        group: this.topicData?.group,
        client_id: this.topicData?.group?.client_id,
        level_id: this.topicData?.group?.level_id,
      }
    },
    ...mapTopicState({
      topicData: (state: any): ITopic => state.currentTopic.data,
      topicReactions: (state: any): Reaction[] => {
        return state.currentTopicReactions
      },
      topicLoading: (state: any): boolean => state.currentTopic.loading,
    }),
  },
  methods: {
    handleOptimisticPostsCount(count: number) {
      this.totalPostsCount = count
    },
    openEditAndScrollToAttachments() {
      ;(this.$refs.topicForm as any).openSheetAndScrollToId(
        "suus__topic-form__attachments"
      )
    },
  },
  watch: {
    topicData(newVal) {
      this.totalPostsCount = newVal.posts_count
    },
  },
  setup() {
    const { t$ } = useTranslate("attachments")
    return {
      t$,
    }
  },
})
</script>

<style lang="sass" scoped>
.suus__topic
  max-width: 1280px
  margin: auto

.suus__topic__expansion-panels::v-deep
  .v-expansion-panel
    background-color: transparent !important
  .v-expansion-panel-header
    padding-left: 0
    text-align: left
</style>
